<template>
  <div id="client-app" class="app">
    <v-app id="client_embed">
      <router-view v-slot="{ Component }">
        <transition mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </v-app>
  </div>
</template>

<script setup lang="ts">
</script>

<style lang="scss">
#client-app {
  @import 'vuetify/dist/vuetify.min.css';
  @import '../../client/styles/index.scss';
}
</style>
